function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHomeBoxphish({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31.667 28.333",
    style: {
      enableBackground: "new 0 0 31.667 28.333"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#41B493",
      strokeWidth: 2,
      strokeMiterlimit: 10
    },
    points: " 10.107,23.167 28.107,23.167 28.107,5.167 10.366,5.167  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "none",
      stroke: "#41B493",
      strokeWidth: 1.9113,
      strokeMiterlimit: 10
    },
    points: " 3.516,20.734 3.516,8.454 9.656,14.594  "
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#41B493"
    },
    cx: 24.225,
    cy: 11.643,
    r: 0.988
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeBoxphish);
export default __webpack_public_path__ + "static/media/icon-home-boxphish.06733f48d9173b24ea4921808365c63d.svg";
export { ForwardRef as ReactComponent };